import { render, staticRenderFns } from "./MerchantDetails/MerchantPickup.html?vue&type=template&id=51140d40&scoped=true&external"
import script from "./MerchantPickup.vue?vue&type=script&lang=js"
export * from "./MerchantPickup.vue?vue&type=script&lang=js"
import style0 from "./MerchantPickup.vue?vue&type=style&index=0&id=51140d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51140d40",
  null
  
)

export default component.exports